import { Component, OnInit } from '@angular/core';
import{ActivatedRoute,Router}from'@angular/router'
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import {MentorAuthService} from'../../../mentor/services/mentor-auth.service'
import {ScholarAuthService}from'../../../scholar/services/scholar-auth.service'
import {AdminAuthService}from'../../../admin/services/admin-auth.service'
import {bounceIn}from '../../animation/animation'
import { trigger, transition } from '@angular/animations';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  animations:[trigger('bounceIn',[
    transition(':enter',[bounceIn])]
    )]
})
export class LoginComponent implements OnInit {
  hide:boolean=true;
  loginError='';
  form:FormGroup;
  type:string='';
  navigate:string=''
  constructor(private route:Router,
              private activatedRoute:ActivatedRoute,
              private mentorService:MentorAuthService,
              private scholarService:ScholarAuthService,
              private adminService:AdminAuthService,private formBuilder:FormBuilder) {
        this.activatedRoute.params.subscribe((param)=>{
        this.type=param['type'];
        this.type=this.normalize(this.type)
        this.navigate=this.type.toLowerCase()
       })
      if(this.type=='Scholar'||this.type=='Mentor'||this.type=='Co-ordinator'){
        if(this.mentorService.isLoggedIn() ){
          this.route.navigate(['/mentor'])
        }
        else if(this.scholarService.isLoggedIn()){
          this.route.navigate(['/scholar'])
        }
        else if(this.adminService.isLoggedIn()){
          this.route.navigate(['/co-ordinator'])
        }
      }
      else{
        this.route.navigate(['/'])
      }
  }


  ngOnInit() {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
    });
  }
  // Submit(form:NgForm){
  //   this.loginError=""
  //     if(form.valid){
  //         switch(this.type){
  //             case 'Mentor':
  //             this.mentorService.login(form.value).subscribe(
  //               (result)=>{
  //                  Swal.fire({type:'success',title:'Logged In',timer:800,showCancelButton:false,showConfirmButton:false}).
  //                  then(()=>{
  //                   this.scholarService.logout()
  //                   this.adminService.logout()
  //                   this.route.navigate(['/mentor'])
  //                 })
  //               },
  //               (err)=>{
  //                 if(err.status===400)
  //                 this.loginError=err.error.error
  //               }
  //             )
  //           break;

  //           case 'Scholar':
  //               this.scholarService.login(form.value).subscribe(
  //                 (result)=>{
  //                     Swal.fire({type:'success',title:'Logged In',timer:800,showCancelButton:false,showConfirmButton:false})
  //                     .then(()=>{
  //                       this.mentorService.logout()
  //                       this.adminService.logout()
  //                       this.route.navigate(['/scholar/meetings/notes'])
  //                     })
  //                  },
  //                 (err)=>{
  //                     if(err.status===400)
  //                       this.loginError=err.error.error
  //                      }
  //               )
  //           break;

  //           case 'Co-ordinator':
  //               this.adminService.login(form.value)
  //               .subscribe(result=>{
  //                 if(result){
  //                   Swal.fire({type:'success',title:'Logged In',timer:800,showCancelButton:false,showConfirmButton:false})
  //                   .then(()=>{
  //                     this.scholarService.logout()
  //                     this.mentorService.logout()
  //                     this.route.navigate(['/co-ordinator'])
  //                   });
  //                 }
  //               },err=>{
  //                 if(err.status===400)
  //                 this.loginError=err.error.error
  //               })
                
  //           break;
  //           default:
  //             this.route.navigate(['/'])
  //           break;

  //         }

  //     }

  // }
  submitForm() {
    if (this.form.valid) {
      this.loginError = '';
      switch (this.type) {
        case 'Mentor':
          this.mentorService.login(this.form.value).subscribe(
            (result) => {
              Swal.fire({ type: 'success', title: 'Logged In', timer: 800, showCancelButton: false, showConfirmButton: false })
                .then(() => {
                  this.scholarService.logout();
                  this.adminService.logout();
                  this.route.navigate(['/mentor']);
                });
            },
            (err) => {
              if (err.status === 400) {
                this.loginError = err.error.error;
                Swal.fire({
                  type: 'error',
                  text: this.loginError,
                  timer:2500, showCancelButton: false, showConfirmButton: false
                })
              }
            }
          );
          break;
  
        case 'Scholar':
          this.scholarService.login(this.form.value).subscribe(
            (result) => {
              Swal.fire({ type: 'success', title: 'Logged In', timer: 800, showCancelButton: false, showConfirmButton: false })
                .then(() => {
                  this.mentorService.logout();
                  this.adminService.logout();
                  this.route.navigate(['/scholar/meetings/notes']);
                });
            },
            (err) => {
              if (err.status === 400) {
                this.loginError = err.error.error;
                Swal.fire({
                  type: 'error',
                  text: this.loginError,
                  timer:2500, showCancelButton: false, showConfirmButton: false
                })
              }
            }
          );
          break;
  
        case 'Co-ordinator':
          this.adminService.login(this.form.value).subscribe(
            (result) => {
              if (result) {
                Swal.fire({ type: 'success', title: 'Logged In', timer: 800, showCancelButton: false, showConfirmButton: false })
                  .then(() => {
                    this.scholarService.logout();
                    this.mentorService.logout();
                    this.route.navigate(['/co-ordinator']);
                  });
              }
            },
            (err) => {
              if (err.status === 400) {
                this.loginError = err.error.error;
                Swal.fire({
                  type: 'error',
                  text: this.loginError,
                  timer:2500, showCancelButton: false, showConfirmButton: false
                })
              }
            }
          );
          break;
  
        default:
          this.route.navigate(['/']);
          break;
      }
    }
  }
  normalize(value:any){
    if(value){
      let val=value.trim().toLowerCase()
      val=val.charAt(0).toUpperCase()+val.slice(1)
      return val;
    }
    else{
      return ''
    }
  }
resetPassword(){
  this.route.navigate(['/reset-password'],{queryParams:{type:this.type}});
}
}
